<template>
  <div>
    <v-tooltip
      top
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          class="avatar"
          :class="{ 'disabled': disabled }"
          @click="onClick"
          v-bind="attrs"
          v-on="on"
          :style="{ backgroundColor: color }"
        >
          {{ initials }}
        </div>
      </template>
      <span>{{ name }}</span>
    </v-tooltip>
  </div>
</template>
<script>
export default {
  name: 'Chip',
  props: {
    item: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    initials: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
  },
  methods: {
    onClick() {
      if (!this.disabled) {
        this.$emit('click');
      }
    },
  },
};
</script>
<style scoped>
.avatar {
  --border: 2px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  margin-right: -5px;
  color: white;
  pointer-events: auto;
  cursor: pointer;
}

.avatar.disabled {
  background-color: #aeaeae !important;
  cursor: default;
}

</style>
